import { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { EffectFade, Autoplay, Pagination } from 'swiper'
import axios from 'axios'
import { static_api_url } from '../config';

SwiperCore.use([EffectFade, Autoplay, Pagination]);
interface Sliders {
  link: string,
  title: any[string],
  banner_url: any[string]
}

const SlidingHero = () => {
  const [sliders, setSliders] = useState<Sliders[]>([])
  useEffect(() => {
    axios.get(`${process.env.PUBLIC_URL}/data/banner.json`)
    .then(res =>
      setSliders(res.data[0])
    )
  }, [])
  return (
    <div className="SlidingHero">
      <div className="inner">
        {sliders.length > 0 && (
          <Swiper
            slidesPerView={1}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false
            }}
            pagination={{ clickable: true }}
            speed={1000}
          >
            {sliders.map((data, key) => (
              <SwiperSlide key={key}>
                <a href="https://www.bca.co.id/salebration" target="_blank" referrerPolicy="no-referrer">
                  <img src={data.banner_url} alt={data.title.rendered} className="w-100 rounded d-block" />
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
      </div>
  )
}

export default SlidingHero